export const operacaoNaPalmaDaMaoContent = {
  heading: "A OPERAÇÃO\nNA PALMA\nDA MÃO",
  body:
    "No Pastejo, campo e escritório trabalham com a mesma informação. Pela versão mobile, a equipe registra as movimentações da rotina operacional, enquanto a gestão acompanha tudo com mais controle, agilidade e precisão no mesmo sistema.",
  features: [
    "Mapa de gado",
    "Suplementação",
    "Manejo de pasto",
    "Avaliação de pastagem",
    "Tarefas de manutenção",
    "Movimentação de lotes",
  ],
} as const;
